import { createResource } from 'react-resource-router';
import { assert, AssertionError } from '@atlassian/eoc-common';
import { eocCommonResources } from '@atlassian/eoc-resources';
import { getAlertDetail, getAlertLogTypesEndpoint, getEntityRelationTypesEndpoint, getResponderStatesEndpoint } from '../endpoints';
export const alertDetailResource = createResource({
  type: 'alertDetailResource',
  getKey: routerContext => `alertDetailResource#${routerContext.match.params.id}`,
  getData: async routerContext => {
    var _routerContext$match$;
    const alertId = (_routerContext$match$ = routerContext.match.params) === null || _routerContext$match$ === void 0 ? void 0 : _routerContext$match$.id;
    assert(!!alertId, new AssertionError('alertDetailResource', 'alertId should be set to fetch alert-detail'));
    return getAlertDetail(alertId);
  },
  isBrowserOnly: true
});
export const logTypesResource = createResource({
  type: 'logTypesResource',
  getKey: routerContext => `logTypesResource#${routerContext.match.params.id}`,
  getData: async () => {
    return getAlertLogTypesEndpoint();
  },
  isBrowserOnly: true
});
export const entityRelationTypesResource = createResource({
  type: 'entityRelationTypesResource',
  getKey: routerContext => `entityRelationTypesResource#${routerContext.match.params.id}`,
  getData: async routerContext => {
    var _routerContext$match$2;
    const alertId = (_routerContext$match$2 = routerContext.match.params) === null || _routerContext$match$2 === void 0 ? void 0 : _routerContext$match$2.id;
    assert(!!alertId, new AssertionError('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
    return getEntityRelationTypesEndpoint(alertId);
  },
  isBrowserOnly: true
});
export const responderStatesResource = createResource({
  type: 'responderStatesResource',
  getKey: routerContext => `responderStatesResource#${routerContext.match.params.id}`,
  getData: async routerContext => {
    var _routerContext$match$3;
    const alertId = (_routerContext$match$3 = routerContext.match.params) === null || _routerContext$match$3 === void 0 ? void 0 : _routerContext$match$3.id;
    assert(!!alertId, new AssertionError('responderStatesResource', 'alertId should be set to fetch responder states'));
    return getResponderStatesEndpoint(alertId);
  },
  isBrowserOnly: true
});
export const resources = [alertDetailResource, logTypesResource, responderStatesResource, entityRelationTypesResource, ...eocCommonResources()];